const CONTRACT_RUSHMIND_STATUS_MESSAGES: Record<string, string> = {
  success: 'O RushMind identificou sugestões no documento.',
  no_suggestions: 'O RushMind não identificou tarefas claras no documento.',
  skipped_too_large: 'O documento é extenso demais para análise automática pelo RushMind.',
  skipped_unsupported: 'Este formato de arquivo não suporta análise automática pelo RushMind.',
  skipped_no_text: 'Não foi possível ler texto legível no documento.',
  skipped_rate_limited: 'Limite de análises do RushMind atingido hoje. Disponível novamente amanhã.',
  unavailable: 'Análise do RushMind indisponível no momento.',
}

export function getContractAiStatusMessage(status: string, fallback?: string | null): string {
  return CONTRACT_RUSHMIND_STATUS_MESSAGES[status] ?? fallback ?? 'Análise do RushMind concluída.'
}
